import React, { useState, useEffect } from 'react';
import axios from "axios";
import { Link, withRouter } from 'react-router-dom';
import {
    GridComponent, ColumnsDirective, ColumnDirective,
    Inject, Page, Sort, Toolbar
} from "@syncfusion/ej2-react-grids";
import { connect } from 'react-redux';

const TransactionHistory = ({ custInfo }) => {
    const cId = parseInt(custInfo.map((item) => item.custId));    
    const [customerTransaction, setcustomerTransaction] = useState([]);
    const [paging, setPaging] = useState(false);
    
    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_BACKEND_BASE_URL}/Transactions/GetTransactionByCustomerId/` + cId)
            .then((response) => {
                setcustomerTransaction(response.data);                
                if (response.data.length > 10) {
                    setPaging(true);
                }
            });
    }, []);    

    const toolbarOptions = [
        "Search"
    ];
    const pageSettingsOptions = {
        pageCount: 3, pageSize: 10, pageSizes: true
    };      
    
    const rowDataBound = args => {       
        if (args.row.ariaRowIndex !== '0') {
            //args.row.cells[6].style.display = 'none';
            args.row.cells[6].className = 'e-rowcell e-templatecell display-none';
            args.row.cells[7].className = 'e-rowcell e-templatecell display-none';
        }       
    };

    return (
        <div className="int-container">
            <div class="container">
                <div class="form-container-large" style={{ width: "100%" }}>
                    <div class="form-group">
                        <h3 style={{ color: "#f19f1f", width: "100%", textAlign: "center" }}>Transaction History</h3>
                    </div>
                    <div>                        
                        <GridComponent id='grdTxn' dataSource={customerTransaction} allowSorting={true} height='auto' rowDataBound={rowDataBound}  
                            allowPaging={paging} pageSettings={pageSettingsOptions} toolbar={toolbarOptions} >
                            <ColumnsDirective>
                                <ColumnDirective field='txnID' headerText='Txn Id' width='80' textAlign='left' visible={true} /> 
                                <ColumnDirective field='txnDate' headerText='Txn Date' width='100' textAlign='left' type='datetime' format='MM/dd/yyyy' />
                                <ColumnDirective field='txnExpiryDate' headerText='Expiry Date' width='100' textAlign='left' type='datetime' format='MM/dd/yyyy' />
                                <ColumnDirective field='termPlan' headerText='Plan Term(m)' width='110' textAlign='Center' />
                                <ColumnDirective field='txnAmount' headerText='Amount' format="C2" width='100' textAlign='right' />                                                                
                                <ColumnDirective width="60"
                                    template={({ txnID }) => (
                                        <Link to='#' style={{color: '#108896'}}>View</Link>                                        
                                    )}
                                />                            
                                <ColumnDirective width="100"
                                    template={({ customerID }) => (
                                        <Link to='/member/membership-subscription' style={{color: '#108896', cursor: 'pointer'}}>Renew Plan</Link>                                        
                                    )}
                                />                               
                                <ColumnDirective width="150"
                                    template={({ txnID }) => (
                                        <Link to='#' style={{color: '#ef5030', cursor: 'pointer'}}>Cancel Membership</Link>                                        
                                    )}
                                />                                                          
                            </ColumnsDirective>
                            <Inject services={[Page, Sort, Toolbar]} />
                        </GridComponent>
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = ({ login: { custInfo } }) => ({
    custInfo
})

export default connect(mapStateToProps)(withRouter(TransactionHistory));